import { React, useState } from 'react';
import Modal from '../Modal';
import './index.scss';

const Shapes = ({ shape, show, setShow, onChange }) => {
  const [selectedShape, setSelectedShape] = useState(shape);

  if (!show) {
    return null;
  }

  const onClickShape = (event) => {
    event.preventDefault();
    
    setSelectedShape(event.currentTarget.dataset.shape);
  };

  const onClick = (event) => {
    event.preventDefault();

    onChange(selectedShape);
    setShow(false);
  };

  const onClickClose = (event) => {
    event.preventDefault();

    setShow(false);
  };

  return (
    <Modal title='Selecciona la forma' fast={true}>
      <div className='shapes-container'>
        <button className={selectedShape === 'line' ? 'shape is-active' : 'shape'} onClick={onClickShape} data-shape='line'>
          <i className='shape__decoration shape__decoration--line'></i>
          <span className='shape__text'>Línea</span>
        </button>
        <button className={selectedShape === 'rectangle' ? 'shape is-active' : 'shape'} onClick={onClickShape} data-shape='rectangle'>
          <i className='shape__decoration shape__decoration--rectangle'></i>
          <span className='shape__text'>Rectángulo</span>
        </button>
        <button className={selectedShape === 'circle' ? 'shape is-active' : 'shape'} onClick={onClickShape} data-shape='circle'>
          <i className='shape__decoration shape__decoration--circle'></i>
          <span className='shape__text'>Círculo</span>
        </button>
        <button className={selectedShape === 'triangle' ? 'shape is-active' : 'shape'} onClick={onClickShape} data-shape='triangle'>
          <i className='shape__decoration shape__decoration--triangle'></i>
          <span className='shape__text'>Triángulo</span>
        </button>
      </div>
      <button className='button button--tool' onClick={onClick}>
        Escoger
      </button>
      <button className='button button--tool' onClick={onClickClose}>
        Cancelar
      </button>
    </Modal>
  );
};

export default Shapes;
